module.exports = __webpack_public_path__ + "static/media/BAP5.3f33be0a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/tutorials/BAP5.png
 ** module id = 683
 ** module chunks = 0
 **/